var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticStyle: { "z-index": "733" },
      attrs: { persistent: "", "max-width": "500", light: true },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c("v-card", { on: { click: _vm.installNow } }, [
            _c(
              "div",
              { staticClass: "safeScroll" },
              [
                _c("v-card-title", { staticClass: "headline" }, [
                  _vm._v("Möchtest du ein Icon für die App hinzufügen? "),
                ]),
                _c("v-card-text", { staticClass: "text-left" }, [
                  _vm._v(
                    " Du kannst die App jetzt in sekundenschnelle installieren, ohne Download! "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "pa-1 text-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "okBtn ma-2 btn-df",
                        attrs: { rounded: "", large: "", text: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            $event.stopPropagation()
                            return _vm.installNow.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" Hinzufügen ")]
                    ),
                    _c("div", { staticClass: "mt-4 underline text-center" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.closeDialog.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Abbrechen")]
                      ),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "pb-3" }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }